/** Available reward types. */
export var RewardType;
(function (RewardType) {
    RewardType["UNDEFINED"] = "UNDEFINED";
    RewardType["DISCOUNT_AMOUNT"] = "DISCOUNT_AMOUNT";
    RewardType["COUPON_REWARD"] = "COUPON_REWARD";
    RewardType["CUSTOM_REWARD"] = "CUSTOM_REWARD";
})(RewardType || (RewardType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map